import React from "react";
import Blog_50_5 from "../component/Blog_50_5";
function Blog_50_5_container() {
  return <Blog_50_5 />;
}

export default Blog_50_5_container;
